import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { errorText, isReasonValid, meaningfulLen } from "@/lib/stageReversal";

const fmt = (n) => Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 3 });

// RR04 · B-2 · reversal confirmation with mandatory reason (DEF-ST-1 contract).
export const ReverseTransferDialog = ({ transfer, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const valid = isReasonValid(reason);

  const submit = async () => {
    if (!valid || submitting) return;
    setSubmitting(true);
    setError("");
    try {
      await api.delete(`/stage-transfers/${transfer.id}`, { data: { reason: reason.trim() } });
      toast.success(`Transfer reversed · ${fmt(transfer.qty)} ${transfer.uom || ""} ${transfer.rm_code || ""} restored to source`);
      onDone();
    } catch (e) {
      setError(errorText(e));
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o && !submitting) onClose(); }}>
      <DialogContent data-testid="st-reverse-dialog">
        <DialogHeader>
          <DialogTitle>Reverse stage transfer</DialogTitle>
          <DialogDescription>
            {transfer.movement_no || transfer.id} · {transfer.rm_code} · {fmt(transfer.qty)} {transfer.uom} · from {transfer.godown_name}.
            Full, audit-preserving reversal — the original record is kept and marked reversed.
          </DialogDescription>
        </DialogHeader>
        <Textarea data-testid="st-reverse-reason" value={reason} disabled={submitting}
          onChange={(e) => setReason(e.target.value)} placeholder="Reason for reversal (required)" />
        <div className="text-xs text-zinc-500" data-testid="st-reverse-reason-hint">
          {meaningfulLen(reason)}/4 letters or digits minimum
        </div>
        {error && <div className="text-sm text-red-400" data-testid="st-reverse-error">{error}</div>}
        <DialogFooter>
          <button data-testid="st-reverse-cancel" onClick={onClose} disabled={submitting}
            className="h-9 px-4 border border-[var(--border)] rounded-sm text-sm disabled:opacity-40">Cancel</button>
          <button data-testid="st-reverse-confirm" onClick={submit} disabled={!valid || submitting}
            className="h-9 px-4 rounded-sm text-sm bg-amber-500/20 border border-amber-500/50 text-amber-200 disabled:opacity-40 disabled:cursor-not-allowed">
            {submitting ? "Reversing…" : "Confirm reversal"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
